import React from "react";

const Option = ({ selected }) => {
  return (
    <div className="optbg">
      <label htmlFor="opt">縣市選擇</label>
      <select id="opt" onChange={selected}>
        <option>臺北市</option>
        <option>新北市</option>
        <option>桃園市</option>
        <option>新竹市</option>
        <option>新竹縣</option>
        <option>苗栗縣</option>
        <option>基隆市</option>
        <option>宜蘭縣</option>
        <option>臺南市</option>
        <option>臺中市</option>
        <option>雲林縣</option>
        <option>南投縣</option>
        <option>彰化縣</option>
        <option>嘉義市</option>
        <option>嘉義縣</option>
        <option>高雄市</option>
        <option>屏東縣</option>
        <option>臺東縣</option>
        <option>花蓮縣</option>
        <option>澎湖縣</option>
        <option>金門縣</option>
        <option>連江縣</option>
      </select>
    </div>
  );
};

export default Option;
